/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow_up': {
    width: 16,
    height: 16,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M745.376 662.624L512 429.248 278.624 662.624l-45.248-45.248L512 338.752l278.624 278.624z" _fill="#787878"/>'
  }
})
